export const handleSureviewEmailInput = (
  setCamerasObject: any,
  camerasObject: any,
  inputString: any,
  objectId: number
) => {
  const newObject = camerasObject[objectId];

  newObject.sureview.sureview_email = inputString;

  setCamerasObject((previousState: any) => {
    return { ...previousState, objectId: newObject };
  });
};
